var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({
    background: _vm.$vuetify.theme.themes[_vm.theme].background,
    color: '',
  })},[_c('app-bar'),_c('side-bar'),_c('base-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }